import Dashboard from './GIPL_Dashboard_Connected';
export default Dashboard;